import { compareAccommodationItemsByPrice } from '@web-platform/shared-banana-utils-frontend/src/helpers/compareAccomodationItems';
import { PAGE_TYPE_EXPLORE_CITY_DRAWER } from '@web-platform/shared-universal-constants/src/michelin';
import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { MICHELIN_HOTEL_EXPLORE_DESTINATION_CHANGED } from '@web-platform/shared-universal-redux/src/actions/michelin';
import {
  MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH,
  MICHELIN_GET_HOTEL_CARHIRE_POLLING,
} from '@web-platform/shared-universal-types/src/network/requestTypes';

import type {
  SkyscannerMichelinSearchV1Accommodationssection,
  SkyscannerMichelinSearchV1Search,
} from '@skyscanner-internal/michelin-web-http-client';
import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { ExploreAccommodationsState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/exploreAccommodations';

type Accommodation = SkyscannerMichelinSearchV1Accommodationssection.Accommodation;
type SearchResponse = SkyscannerMichelinSearchV1Search.SearchResponse;

const INITIAL_STATE: ExploreAccommodationsState = {
  id: null,
  items: {},
  token: null,
  complete: false,
  currentDestinationId: null,
};

const mapAccommodationItems = (body?: SearchResponse): Accommodation[] => {
  const results = body?.sections?.find((s) => s?.accommodations)?.accommodations?.results;

  if (!results) {
    return [];
  }

  return Object.values(results);
};

export default (
  state: ExploreAccommodationsState = INITIAL_STATE,
  action: Action,
): ExploreAccommodationsState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      if (
        (action.payload.type !== MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH &&
          action.payload.type !== MICHELIN_GET_HOTEL_CARHIRE_POLLING) ||
        action.payload.variables?.pageType !== PAGE_TYPE_EXPLORE_CITY_DRAWER ||
        action.payload.response?.error
      ) {
        return state;
      }

      const { variables } = action.payload;
      const destinationId =
        // @ts-expect-error(2339): entityIds can be undefined
        variables?.trip?.tripSegments?.[0]?.destinations?.locations?.entityIds?.[0];

      if (!destinationId) {
        return state;
      }

      const accommodationItems = mapAccommodationItems(action.payload.response.body);
      const sortedAccommodationItems = [...accommodationItems].sort(
        compareAccommodationItemsByPrice,
      );

      return {
        id: action.payload.response.body?.pollingSession?.token ?? null,
        items: {
          ...state.items,
          [destinationId]: sortedAccommodationItems,
        },
        token: action.payload.response.body?.pollingSession?.token ?? null,
        complete: action.payload.response.body?.pollingSession?.complete ?? false,
        currentDestinationId: destinationId,
      };
    }

    case MICHELIN_HOTEL_EXPLORE_DESTINATION_CHANGED: {
      return {
        ...INITIAL_STATE,
        items: state.items,
      };
    }

    default:
      return state;
  }
};

export const get = (state: ExploreAccommodationsState): ExploreAccommodationsState => state;
